import { render } from "./clientes-leads.vue?vue&type=template&id=47ab1d28"
import script from "./clientes-leads.vue?vue&type=script&lang=js"
export * from "./clientes-leads.vue?vue&type=script&lang=js"

import "./clientes-leads.vue?vue&type=style&index=0&id=47ab1d28&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__